import {youthClass, techniqueClass, performanceClass} from '../asset';

const homeStrings = {
    home: {
        title: "TGDANCESPORT",
        slogan: "Group classes. Private lessons. Sport training. And so much more.",
        section1_title: "A HAPPY, HEALTHY AND EXTRAORDINARY LIFE AWAITS. START DANCING WITH US!",
        section1_content: "​Welcome to TGDancesport! Tony and Gloria are internationally trained professional ballroom dance instructors based in Vancouver BC, Canada. You will find all the information about their group classes for beginners, social dancers, and competitors on this website. They offer ballroom dance lessons for everyone starting from age 4 to adults of all ages. Come join the fun and learn how to ballroom dance in a friendly and relaxed environment. Looking for the best ballroom dance instructors who are also world class competitive dancers and experienced teachers? Register for their group classes and learn from Champions who are passionate about teaching you how to dance!",
        section2_title: "Classes We Offer",
        section2_content: "We offer a variety of classes for all ages and levels. Here are some of our highlighted classes. To find out which class suits you the best, feel free to reach out to us! We are happy to help you find the right class for you!",
        section3_title: "What Students Are Saying",
        section4_title: "Gallery",
    },
    home_class_info: [
        {
            title: "For Kids",
            text: [
                "• Mini Dancer Program (Age 4-6): Learn basic movements and improve coordination",
                "• Young (7-10) & Junior (11+) Dance Program: Introduction to ballroom dance and learn basic steps and techniques",
            ],
            src: youthClass,
        },
        {
            title: "For Adults",
            text: [
                "• Adult Social Class: Learn basic steps and techniques of ballroom dance",
                "• Technique Class: Improve your dancing with proper techniques and exercises",
                "• Performance Training Class: Drills and exercises designed specifically for dancers",
                "• Conditioning Class: Improve your strength, flexibility, stamina and core for dancing",
            ],
            src: techniqueClass,
        },
        {
            title: "Private Events",
            text: [
                "• Birthday Party: Have a fun dance lesson with your friends and family",
                "• Corporate Event: Have a fun dance lesson with your colleagues",
                "• Private Group Classes: For groups who are interested in learning how to dance together",
            ],
            src: performanceClass,
        },
    ],
    home_testimonials: [
        {
            testimonial: "Tony and Gloria always put in extra time and effort to make sure I am on track to becoming the dancer of my dreams.",
            author: "Cindy",
        },
        {
            testimonial: "Tony and Gloria are excellent teachers that offer clear and concise instructions to dancers of all levels. They are fun, energetic and offer a positive learning environment for anyone interested in the art form.",
            author: "Anonymous",
        },
        {
            testimonial: "The ballroom dance classes with Tony and Gloria are a lot of fun. As a beginner it is easy to learn the steps and follow the teachers, as they create a comfortable environment for you to learn how to dance even if you have 2 left feet. It's also an exciting weekly activity to do with your significant other!",
            author: "Cecilia"
        },
        {
            testimonial: "I am very picky with my dance coaches, but once I found Tony and Gloria, I stopped looking. If you view dance as both a sport and an art form, truly value mastery of the fundamentals, and care about correct and safe body coordination, these are the people to go to. They will put your learning first and help you achieve your potential.",
            author: "Masha"
        },
        {
            testimonial: "They're not just dance coaches, they're the dynamic duo of encouragement.",
            author: "Grant"
        },
        {
            testimonial: "I met Tony and Gloria many years ago. What inspired me to pursue my passion with them is their dedication to their students as they continue to strive to become better teachers as they frequently travel back to Italy to train under their coaching",
            author: "John"
        },
        {
            testimonial: "Got dragged in by a friend, tried a few lessons, never looked back. Thanks Tony & Gloria for being the best coaches in dance and in life!",
            author: "Josh"
        },
        {
            testimonial: "Tony and Gloria are wonderful instructors with a fun and engaging dynamic. They make the classes enjoyable all while ensuring you are learning the proper techniques. No matter what your skill level, they are super encouraging and able to find creative and intuitive ways to help you be confident on the dance floor!",
            author: "Anonymous"
        },
        {
            testimonial: "Tony and Gloria's philosophy on fitness and technique made me feel like I had explosive improvement after my first handful of classes with them. I have a LONG way to go still but I feel like my technique habits get a little better everytime I see them.",
            author: "Tim"
        },
        {
            testimonial: "Dancing under TG Dancesport has been a wonderfully welcoming experience on the path to excellence. Taking part in their performance class has been great for targeting technique and building stamina so we are competition ready. The private coaching lessons are so helpful. I feel safe and encouraged under their instruction. Being part of the TG team feels like family!",
            author: "Dom"
        },
        {
            testimonial: "Tony and Gloria inspire me every day to become a better dancer. Both on and off the dance floor, they are my role models and have helped me through many ups and downs. They make dancing so much fun and meaningful - I'm so happy I chose them as coaches.",
            author: "Amy"
        },
        {
            testimonial: "We highly recommend Tony and Gloria's ballroom dance classes. Their passion for dancing is evident, and their expertise as instructors is impressive. Their patient guidance and attention to detail have helped us improve our dancing and their classes are well structured, allowing for noticeable progress week after week.",
            author: "Melanie & Nolan"
        },
        {
            testimonial: "My dance partner and I were blessed to have Tony and Gloria as our coaches after we had been dancing and competing for a few years and were wanting something more. We chose them as they were beautiful dancers whom we had seen compete and perform many times, and we knew they were teaching the most up-to-date information from a school of world champions in Europe. Tony and Gloria blew us out of the water, exceeding our expectations on multiple fronts. We found ourselves with not just an incredible set of dance coaches but wonderful mentors and friends for life.",
            author: "Victoria"
        },
    ],
};

export default homeStrings;
